import { render } from "./MMEditCouncil.vue?vue&type=template&id=1a8d7e77"
import script from "./MMEditCouncil.vue?vue&type=script&lang=js"
export * from "./MMEditCouncil.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__